import Environment from "../config"
export const envconfig = Environment;

export const get = (key: string) => {
    return envconfig[key];
}
